.poweredBy {
  font-size: 13px;
  display: flex;
  align-items: center;

  color: #201f23;
  text-decoration: none;
  transition: color 0.15s;
}

/* 
  Product decision to use the background fill. If they change their minds
  simply uncomment the following rules!
*/
/* .poweredBy svg path {
  fill: #201f23;
}

.poweredBy :global(.logo-fill) {
  fill: #e6006f00;
} */

.poweredBy svg path,
.poweredBy :global(.logo-fill) {
  transition: fill 0.15s;
}

.poweredBy:hover,
.poweredBy:focus {
  color: #e6006f;
}

.poweredBy:hover svg path,
.poweredBy:focus svg path {
  fill: #fff;
}

.poweredBy:hover :global(.logo-fill),
.poweredBy:focus :global(.logo-fill) {
  fill: #e6006f;
}

.poweredBy > * {
  flex: 0 0 auto;
}

.svg {
  height: 20px;
  margin-left: 3px;
}
